const isLocalhost = window.location.hostname === 'localhost'

export const SERVER_URL = 'https://staging-platform.carebrain.ai'

export const WIDGET_BASE_URL = isLocalhost ? 'http://localhost:3030' : SERVER_URL + '/widget'
export const WIDGET_BASE_URL_WITH_LOGIN = isLocalhost ? 'http://localhost:3032' : SERVER_URL + '/widget/login'

export const EMBEDDED_AI_CHAT_BASE_URL = isLocalhost
  ? 'http://localhost:3031'
  : 'https://bep-embedded-ai-chat.vercel.app'

// Url of backend on a server (server url + nginx prefix for requests to tomcat)
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || SERVER_URL + '/api'

export const BASE_URL = process.env.REACT_APP_BASE_URL || BACKEND_URL + '/private'

export const HOME_PATH = process.env.REACT_APP_HOME_PATH || '/admin'

export const USE_MESSAGE_KEYS = process.env.REACT_APP_USE_MESSAGE_KEYS !== '0'

/** Unauthenticated protected entry → Auth0 careplan authorize (silent SSO). */
export const AUTH0_CAREPLAN_AUTHORIZE_URL = `${BACKEND_URL}/auth0/authorize?dest=careplan&silent=true`

/** Auth0 users: ends the backend + Auth0 session, then returns to careplan. */
export const AUTH0_CAREPLAN_LOGOUT_URL = `${BACKEND_URL}/auth0/logout?dest=careplan`

// The QCS portal paired with each backend; SERVER_URL is what differs per environment branch.
const QCS_PORTAL_URL_BY_SERVER = {
  'https://dev-platform.carebrain.ai': 'https://stagingportal.qcs.co.uk/',
  'https://staging-platform.carebrain.ai': 'https://prerelportal.qcs.co.uk/',
  'https://api.carebrain.ai': 'https://portal.qcs.co.uk/',
}

/** "Back to home" and the handoff error page's "QCS login" target. */
export const QCS_LOGIN_URL =
  process.env.REACT_APP_QCS_LOGIN_URL ||
  QCS_PORTAL_URL_BY_SERVER[SERVER_URL] ||
  'https://prerelportal.qcs.co.uk/'

/** sessionStorage: set before Auth0 navigate; avoids redirect loops back to authorize. */
export const AUTH0_CAREPLAN_REDIRECT_FLAG = 'auth0-careplan-redirect'

/** sessionStorage: soft getAdminUser probe after Auth0 — skip global 401 logout. */
export const AUTH0_SESSION_PROBE_FLAG = 'auth0-session-probe'

/** sessionStorage: probe already failed this Auth0 attempt — do not re-probe. */
export const AUTH0_SESSION_PROBED_FLAG = 'auth0-session-probed'

/** sessionStorage: this tab entered through the QCS handoff (/login?type=qcs&id=) — shows "Back to home". */
export const QCS_HANDOFF_SESSION_FLAG = 'qcs-handoff-session'

/** sessionStorage: handoff user left through Auth0 logout; the return trip goes on to QCS. */
export const QCS_HANDOFF_LOGOUT_FLAG = 'qcs-handoff-logout'
